module.exports = __webpack_public_path__ + "media/img/vca/bg-category-864cb9b085688f45b86887a9a4a611db.png";